"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.groupItemsWrapper = exports.groupContainer = exports.gridWrapper = exports.userItemWrapper = void 0;

var _reactEmotion = require("react-emotion");

var userItemWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("position:relative;&.listView{margin-top:8px;}&.gridView{margin:12px 10px;}");
exports.userItemWrapper = userItemWrapper;
var gridWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("width:100%;");
exports.gridWrapper = gridWrapper;
var groupContainer =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;flex-direction:column;&.listView{padding:10px 0px 6px 0px;}&.gridView{}");
exports.groupContainer = groupContainer;
var groupItemsWrapper =
/*#__PURE__*/
(0, _reactEmotion.css)("display:flex;&.listView{flex-direction:column;margin:12px 0px;}&.gridView{flex-direction:row;flex-flow:wrap;margin:12px -10px;}");
exports.groupItemsWrapper = groupItemsWrapper;